"use strict";

module.exports = /*@ngInject*/function () {
  return {
    restrict: 'AE',
    scope: true,
    bindToController: {
      id: '@',
      form: '=',
      label: '@',
      campusCode: '@',
      selectedPerson: '=ngModel',
      ngRequired: '=ngRequired',
      ngDisabled: '=ngDisabled',
      showError: '=showError',
      onSelect: '&',
      noResults: '='
    },
    templateUrl: 'shared/components/person-search/person.search.html',
    controllerAs: 'sCtrl',
    // eslint-disable-next-line object-shorthand
    link: function link(scope) {
      // eslint-disable-next-line no-param-reassign
      scope.sCtrl.campus_code = {
        campusCode: scope.sCtrl.campusCode
      };
    },
    // eslint-disable-next-line object-shorthand
    controller: /*@ngInject*/function controller($http, $q, PersonService, ProfileService, ConfigService, CampusService) {
      var sCtrl = this;
      var _ConfigService$getCon = ConfigService.getConfig(),
        PROFILE_URL = _ConfigService$getCon.PROFILE_URL;
      sCtrl.isSuperUser = ProfileService.isSuperUser();
      sCtrl.helpText = "<ol class='help-steps'><li>Try narrowing your search by entering additional characters.</li><li>Please ask them to login to <a href='".concat(PROFILE_URL, "' target='_blank' class='text-group'>Profile</a> and review their profile information.</li><li> If you continue to experience problems searching for an individual, please contact the Service Desk at <a href='mailto:service@RiskandSafetySolutions.com'>service@RiskandSafetySolutions.com</a></li></ol>");
      sCtrl.init = function () {
        sCtrl.getCampuses();
      };
      sCtrl.getCampuses = function () {
        CampusService.query().$promise.then(function (results) {
          sCtrl.campuses = results;
        });
      };
      sCtrl.typeaheadLoading = false;
      sCtrl.selectPerson = function ($item) {
        PersonService.upsertToCore({}, {
          userId: $item.userId
        });
        sCtrl.onSelect()($item);
      };
      sCtrl.clearSelectedPerson = function () {
        sCtrl.selectedPerson = undefined;
        sCtrl.onSelect()({
          userId: null,
          firstName: null,
          lastName: null,
          email: null,
          campusCode: null
        });
      };
      sCtrl.personSearch = function (query) {
        sCtrl.typeaheadLoading = true;
        return $q(function (resolve, reject) {
          PersonService.search({
            campusCode: sCtrl.campus_code.campusCode,
            terms: query
          }).$promise.then(function (data) {
            sCtrl.typeaheadLoading = false;
            resolve(data);
          })["catch"](reject)["finally"](function () {
            sCtrl.typeaheadLoading = false;
          });
        });
      };
      sCtrl.cancel = function () {
        sCtrl.displayOptions = undefined;
      };
      sCtrl.init();
    }
  };
};